/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Current form state

Values: submitted=Submitted, in-progress=InProgress, expired=Expired
 * @export
 * @enum {string}
 */

export enum FormState {
    Submitted = 'submitted',
    InProgress = 'in-progress',
    Expired = 'expired'
}


